export const GET_ACCOUNT_BY_ID = 'app/profile/getAccountById';
export const MANAGE_ACCOUNT = 'app/profile/manageAccount';
